import { render, staticRenderFns } from "./Improve.vue?vue&type=template&id=7c1bf06f&scoped=true&lang=pug"
import script from "./Improve.vue?vue&type=script&lang=ts"
export * from "./Improve.vue?vue&type=script&lang=ts"
import style0 from "./Improve.vue?vue&type=style&index=0&id=7c1bf06f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1bf06f",
  null
  
)

export default component.exports